import styled from "@emotion/styled";
import { BASE_COLORS } from "../../../../../../../../../../emotion-theme";

export const HostContainer = styled.div`
  display: block;
  height: 100%;
  padding: 4px;
`;

export const Content = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
`;

export const ProductImages = styled.div`
  min-width: 0;
  max-height: 25%;
  width: 100%;
`;

export const ProductImg = styled.img`
  display: inline;
  max-height: 100%;
  width: auto;
  max-width: 45%;
  margin: 0 4px;
  border-radius: 12px;
  box-shadow: 0 4px 10px 2px ${BASE_COLORS.slightLightGray};
`;
export const Products = styled.div`
  display: block;
  padding: 8px;
  width: 100%;
  text-align: left;
  overflow-y: auto;
`;
